/**
 * @fileOverview View for mobile date range picker, using React component.
 * @author jzetlen
 *
 */

import { validateConfig } from './desktopView';
import createRenderer from 'component-datepicker/dist/create-renderer';
import Month from 'component-datepicker/dist/components/Month';
import { composeStore } from './storeUtils';
import datePickerStore from './stores/base';
import mouseHandling from './stores/mouseHandling';

export default function createMobileDateRangePicker(config) {
	validateConfig(config);

	// create view renderer of shape { render, remove }
	const pickerView = createRenderer(Month, config.el);

	const pickerStore = composeStore([
		mouseHandling(config),
		datePickerStore(config)
	]);

	pickerStore.onUpdate(renderPicker);

	pickerStore.onPublish(submitDates);

	renderPicker();

	return pickerStore;

	function renderPicker() {
		pickerView.render(pickerStore.getState());
	}

	function submitDates(event, startDate, endDate) {
		config.onDateChange(event, { startDate, endDate });
	}
}



// WEBPACK FOOTER //
// ./view/activity/dateRangePicker/mobileView.es6